import { render, staticRenderFns } from "./SampleNewPage.vue?vue&type=template&id=33c19b19&"
import script from "./SampleNewPage.vue?vue&type=script&lang=js&"
export * from "./SampleNewPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports